import axios from 'axios';
import store from '@/store';
import router from '@/router';

//axios.defaults.baseURL = 'http://192.168.6.14/api/'
//axios.defaults.baseURL = 'http://talloaks.io/api/'
//axios.defaults.baseURL = 'http://api.talloaks.io/'
//axios.defaults.baseURL = 'http://192.168.3.15/api/'
//axios.defaults.baseURL = 'http://cloud.ouzel.land/api/'
//axios.defaults.baseURL = 'http://192.168.11.22/api/'
axios.defaults.baseURL = '/api'
const PAGE_MESSAGE = 'PageMessages/ADD_MESSAGE';

// serialize the query parameters
const urlParameters = (args) => {
  const params = new URLSearchParams();
  Object.keys(args).forEach((key) => {
    if (typeof args[key] === 'object') {
      params.append(key, JSON.stringify(args[key]));
    } else {
      params.append(key, args[key]);
    }
  });
  return params;
}

const buildFormData = (formData, data, parentKey) => {
  if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
    Object.keys(data).forEach(key => {
      buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
    });
  } else {
    const value = data == null ? '' : data;
    formData.append(parentKey, value);
  }
}

function handleError(err) {
  if (axios.isCancel(err)) {
    // console.log('Canceled request', err.message)
    throw err;
  } else if (err.response.status === 401) {
    localStorage.removeItem('acornsToken');
    router.push('/login');
    throw err;
  } else if (err.response.status === 411) {
    store.commit(PAGE_MESSAGE, {
      type: 'api-error',
      params: { label: 'API info', data: err.response.data },
      active: true,
    });
    throw err;
  } else if (err.response.status === 500) {
    // this is a catastrophic error, somethign that could not be
    // caught by the backend for some reason. We need to be aware
    // of these errors so that we can fix and/or catch them
    // store.commit('pageMessages/ADD_MESSAGE', {
    //   type: 'api-error',
    //   params: { label: 'API info', data: err.response.data },
    //   active: true.
    // });
    //console.log('500 API ERROR', err.response);
    throw err;
  } else {
    //console.log('UK API ERROR', err.response);
    // store.commit('pageMessages/ADD_MESSAGE', {
    //   type: 'api-error',
    //   params: { label: msg, data: err.response.data },
    //   active: true,
    // });
    throw err;
  }
}

function handleResponse(res){
  //console.log(res)
  if(res.data.responseType){
    // check to see what type of object we are dealing with
    if(res.data.results[0] && res.data.results[0].data){
      // most likely a search object
      return res.data.results[0];
    } else {
      // most likely a collection of stuff
      return res.data.results;
    }
  }
  return res.data
}

function request({ url, method, headers, params, cancelToken }) {
  // get the token from storage
  // const token = localStorage.getItem('acornsToken');
  const token = '30675efc94369b04c56717c84176353d83b8b4b78f13ae32';
  const options = { headers: { ...headers, Authorization: token }, cancelToken }
  //console.log('url', params)
  if(method === 'post'){
    return axios.post(url, params, options)
      .then( res => handleResponse(res))
      .catch( err => handleError(err));
  } else if(method === 'delete'){
    return axios.delete(url, options)
      .then( res => handleResponse(res))
      .catch( err => handleError(err));
  } else if(method === 'put'){
    return axios.put(url, params , options)
      .then( res => handleResponse(res))
      .catch( err => handleError(err));
  } else if(method === 'patch'){
    return axios.patch(url, params, options)
      .then( res => handleResponse(res))
      .catch( err => handleError(err));
  } else {
    return axios.get(url, { params, ...options })
      .then( res => handleResponse(res))
      .catch( err => handleError(err));
  }
}

export function fetch(url, args = {}, cancel) {
  const params = urlParameters(args);
  const cancelToken = cancel ? cancel.token : null;
  console.log('get cancel', url, cancelToken);
  const headers = {}
  const method = 'get';
  return request({
    url,
    method,
    params,
    headers,
    cancelToken,
  })
}

export function remove(url, args = {}, cancel) {
  const params = urlParameters(args);
  const cancelToken = cancel ? cancel.token : null;
  const headers = {}
  const method = 'delete';
  return request({
    url,
    method,
    params,
    headers,
    cancelToken,
  })
}

export function post(url, args = {}, cancel) {
  const params = new FormData();
  buildFormData(params, args);
  const cancelToken = cancel ? cancel.token : null;
  const headers = { 'Content-Type' : 'multipart/form-data' }
  const method = 'post';
  return request({
    url,
    method,
    headers,
    params,
    cancelToken,
  })
}

export function put(url, args = {}, cancel) {
  //const params = asFormData(args);
  const params = urlParameters(args);
  const cancelToken = cancel ? cancel.token : null;
  const headers = {}
  const method = 'put';
  return request({
    url,
    method,
    params,
    headers,
    cancelToken,
  })
}

export function patch(url, args = {}, cancel) {
  const params = asFormData(args);
  const cancelToken = cancel ? cancel.token : null;
  const headers = {}
  const method = 'patch';
  return request({
    url,
    method,
    params,
    headers,
    cancelToken,
  })
}
